// Single source of truth for "is this visitor still here right now?".
//
// The widget heartbeats every 10s with the visitor's current presence status
// (browsing | engaged | idle | departed). The agent UI used to derive the
// LIVE marker straight from that status — anything but browsing/engaged
// would drop the LIVE tag immediately. Two failure modes followed:
//
//   1. Visitor leaves the widget tab idle 60s+ → widget emits status='idle'
//      → agent monitor row drops LIVE, even though the visitor is still on
//      the page and reachable.
//   2. Widget emits no heartbeat (network blip, agent socket disconnect, tab
//      throttling) → no fresh event arrives → status stays whatever it was
//      last set to and can lie in either direction.
//
// What an agent actually wants to know is whether the visitor is REACHABLE:
// did we hear from them recently and they haven't said goodbye? Status is
// still useful as a label ("idle", "browsing") but should not gate LIVE.
import type { VisitorRow } from '../stores/visitors';

// Heartbeat is 10s. Two missed beats + a small grace window before we
// conclude the widget is gone.
const LIVE_GRACE_MS = 25_000;

export function isVisitorLive(row: VisitorRow, now: number = Date.now()): boolean {
  if (row.status === 'departed') return false;
  return now - row.seenAt < LIVE_GRACE_MS;
}
